import { usePut } from '../../../sharedModules/hooks/useQuery';

interface UpdateParams {
  acctNo: string;
  location: string;
  attachInvoices: boolean;
}

interface UpdateResponse {
  acct_no: string;
  attach_invoices: boolean;
}

export function useUpdateStatementAttachInvoices() {
  const mutation = usePut<UpdateResponse>();

  const updateStatementAttachInvoices = ({ acctNo, location, attachInvoices }: UpdateParams) =>
    mutation.mutateAsync({
      url: `/collections/statements/${acctNo}/attach_invoices?location=${encodeURIComponent(location)}`,
      data: { statement: { attach_invoices: attachInvoices } },
    });

  return {
    updateStatementAttachInvoices,
    isLoading: mutation.isPending,
    isError: mutation.isError,
  };
}
